<template>
  <div class="search-members">
    <h1 class="search-members__title" v-if="activeTab !== 1">{{ trans.get('pages:visitors.header') }}<span>.</span></h1>
    <h1 class="search-members__title" v-else>{{ trans.get('pages:members.filters_panel.header') }}<span>.</span></h1>

    <div class="search-members__gender" v-if="searchWindowOpen && activeTab === 1">
      <label class="desc desc--bold">{{ trans.get('pages:members.filters_panel.show') }}:</label>
      <div class="gender">
        <div class="gender__item">
          <div class="checkbox-icon checkbox-icon--male">
            <input type="checkbox" v-model="form.genders" id="cb2" value="male" />

            <label for="cb2">{{ trans.get('pages:members.filters_panel.show_boys') }}</label>
          </div>
        </div>
        <div class="gender__item">
          <div class="checkbox-icon checkbox-icon--female">
            <input type="checkbox" v-model="form.genders" id="cb1" value="female" />
            <label for="cb1">{{ trans.get('pages:members.filters_panel.show_girls') }}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="search-members__settings" v-if="searchWindowOpen && activeTab === 1">
      <div v-if="enableNickname" class="settings__nick">
        <div class="form-group">
          <label class="desc desc--bold">{{ trans.get('pages:members.filters_panel.nickname') }}</label>
          <input
            id="nickname"
            class="input--primary"
            :placeholder="trans.get('pages:members.filters_panel.find_by_nick')"
            type="text"
            v-model="form.nickname"
          >
        </div>
      </div>
      <div class="settings__location">
        <div class="form-group">
          <label class="desc desc--bold">{{ trans.get('pages:members.filters_panel.location') }}</label>
          <div class="v-select-fill">
            <input-location-component v-model="form.location_id"></input-location-component>
          </div>
        </div>
      </div>
      <div class="settings__age">
        <div class="form-group">
          <label class="desc desc--bold">{{ trans.get('pages:members.filters_panel.age') }}</label>
          <div class="vue-slider-in">
            <vue-slider
              :value="[form.age_from, form.age_to]"
              :min="18"
              :max="99"
              @change="form.age_from = $event[0]; form.age_to = $event[1]"
              :tooltip-placement="'bottom'"
            ></vue-slider>
          </div>
        </div>
      </div>
      <div class="settings__distance">
        <div class="form-group">

          <label class="desc desc--bold">{{ trans.get('pages:members.filters_panel.distance') }} (km):</label>
          <div class="vue-slider-in">
            <vue-slider
              v-model="form.distance"
              :min="50"
              :max="500"
              :interval="50"
              :tooltip-placement="'bottom'"
            ></vue-slider>
          </div>
        </div>
      </div>
    </div>

    <div class="search-members__icon">
      <i class="demo-icon icon-cards-icon"></i>
    </div>

  </div>
</template>

<script>

import bFormSlider from 'vue-bootstrap-slider/es/form-slider';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { mapGetters } from 'vuex';
import InputLocation from '../Auth/InputLocation';

export default {
  name: 'SearchForm',
  components: { InputLocation, bFormSlider, VueSlider },
  props: {
    value: Object,
    activeTab: Number,
    enableNickname: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      show: false,
      searchWindowOpen: true,
      form: {
        // age: [20, 40],
        genders: [],
        show_girls: true,
        show_boys: true,
        nickname: null,
        age_from: 18,
        age_to: 30,
        location_id: null,
        distance: 50,
      },
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  watch: {
    'form.genders': function (newValue, oldVale) {
      if (newValue.length >= 1) {
        return;
      }

      if (oldVale.length === 0 && newValue.length === 0) {
        this.form.genders = ['female', 'male'];
        return;
      }

      if (oldVale.length >= 1 && newValue.length === 0) {
        if (oldVale[0] === 'female')
          this.form.genders = ['male'];
        if (oldVale[0] === 'male')
          this.form.genders = ['female'];
      }
    },
  },
  mounted() {
    const searchAttr = this.user.search;

    if (searchAttr) {
      this.form.genders = searchAttr.genders || [];
      this.form.age_from = searchAttr.age_from || 20;
      this.form.age_to = searchAttr.age_to || 40;
      this.form.location_id = searchAttr.location_id || (this.user.location ? this.user.location.id : null);
      this.form.distance = searchAttr.distance || 50;
    }

    this.$emit('input', this.form);
  },
};
</script>

<style scoped>

</style>
